export default {
  install(app) {
    app.directive('equal-height', {
      mounted(el, binding) {
        const selectors = Array.isArray(binding.value) ? binding.value : [binding.value || '.box'];

        const adjustHeights = () => {
          selectors.forEach((selector) => {
            const elements = Array.from(el.querySelectorAll(selector));
            if (elements.length === 0) return;

            // Reset heights
            elements.forEach((el) => (el.style.height = 'auto'));

            // Find max height
            const maxHeight = Math.max(...elements.map((el) => el.offsetHeight));

            // Set all to max height
            elements.forEach((el) => {
              el.style.height = `${maxHeight}px`;
            });
          });
        };

        // Initial adjust
        setTimeout(() => {
          adjustHeights();
        }, 0);

        setTimeout(adjustHeights, 0);
        // Adjust after all resources (like images) are loaded
        window.addEventListener('load', adjustHeights);
        // On resize
        window.addEventListener('resize', adjustHeights);

        // Observe DOM changes
        const observer = new MutationObserver(() => {
          adjustHeights();
        });
        observer.observe(el, { childList: true, subtree: true });

        el._adjustHeights = adjustHeights;
        el._equalHeightObserver = observer;
      },
      unmounted(el) {
        window.removeEventListener('resize', el._adjustHeights);
        if (el._equalHeightObserver) {
          el._equalHeightObserver.disconnect();
        }
      },
    });
  },
};
